import _toConsumableArray from "/var/lib/jenkins/workspace/yesep-ui/node_modules/@babel/runtime-corejs2/helpers/esm/toConsumableArray.js";
import "core-js/modules/es6.function.name";
import "core-js/modules/web.dom.iterable";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { ModalFormMixin } from '@/mixins/ModalFormMixin';
import { GetSiteIdMixin } from '@/mixins/GetSiteIdMixin';
import pick from 'lodash.pick';
import { getAction, httpAction } from '@api/manage';
import { queryUserTreeList as _queryUserTreeList } from '@/api/api';
import moment from 'moment';
import IwsUpload from '@comp/upload/IwsUpload';
import SelectAssetModal from '@views/assets/SelectAssetModal';
import SelectAssetChemicalModal from '@views/assets/SelectAssetChemicalModal1';
var columnsItem = [{
  title: '仪器名称',
  dataIndex: 'assetEquipmentId',
  fixed: 'left',
  align: 'center',
  width: '200px',
  scopedSlots: {
    customRender: 'assetEquipmentId'
  }
}, {
  title: '试剂名称',
  dataIndex: 'productChemicalId',
  fixed: 'left',
  align: 'center',
  width: '200px',
  scopedSlots: {
    customRender: 'productChemicalId'
  }
}, {
  title: '使用数量',
  dataIndex: 'usageAmount',
  align: 'center',
  // width: '7%',
  scopedSlots: {
    customRender: 'usageAmount'
  }
}, {
  title: '试剂浓度',
  dataIndex: 'concentration',
  align: 'center',
  // width: '7%',
  scopedSlots: {
    customRender: 'concentration'
  }
}, {
  title: '配置时间',
  dataIndex: 'configureTime',
  align: 'center',
  // width: '10%',
  scopedSlots: {
    customRender: 'configureTime'
  }
}, {
  title: '有效期至',
  dataIndex: 'termOfValidity',
  align: 'center',
  // width: '10%',
  scopedSlots: {
    customRender: 'termOfValidity'
  }
}, {
  title: '更换原因',
  dataIndex: 'reason',
  align: 'center',
  // width: '10%',
  scopedSlots: {
    customRender: 'reason'
  }
}, {
  title: '更换后是否标准',
  dataIndex: 'calibration',
  align: 'center',
  // width: '10%',
  scopedSlots: {
    customRender: 'calibration'
  }
}, {
  title: '更换后是否核查',
  dataIndex: 'verification',
  align: 'center',
  // width: '10%',
  scopedSlots: {
    customRender: 'verification'
  }
}, {
  title: '备注',
  dataIndex: 'remark',
  align: 'center',
  // width: '14%',
  scopedSlots: {
    customRender: 'remark'
  }
}, {
  title: '附件',
  align: 'center',
  width: '80px',
  dataIndex: 'operation',
  scopedSlots: {
    customRender: 'operation'
  }
}];
/*DataSource 定义数据源数组*/

var dataTable = [];
export default {
  name: 'ChemicalReplaceModal',
  mixins: [ModalFormMixin, GetSiteIdMixin],
  components: {
    IwsUpload: IwsUpload,
    SelectAssetModal: SelectAssetModal,
    SelectAssetChemicalModal: SelectAssetChemicalModal
  },
  data: function data() {
    return {
      tablePageIndex: 1,
      codeDict: 'assetEquipmentId,productChemicalId,calibration,verification',
      tabsKey: '1',
      showUpload: false,
      addState: false,
      equipmentOptions: [],
      dataItem: [],
      columnsItem: columnsItem,
      selectedRowKeysTable: [],
      bodyStyle: {
        width: '1000px',
        height: 'auto'
      },
      visiblepProduct: false,
      columns: [{
        title: '名称',
        dataIndex: 'title',
        width: '300px',
        align: 'center'
      }, {
        title: '值',
        dataIndex: 'value',
        align: 'center',
        width: '300px',
        scopedSlots: {
          customRender: 'value'
        }
      }, {
        title: '附件',
        dataIndex: 'action',
        align: 'center',
        scopedSlots: {
          customRender: 'action'
        }
      }],
      tableData: [],
      selectedRowKeyss: [],
      title: '试剂更换表单',
      tableName: 'om_chemical_replace',
      form_fields: ['siteId', 'userId', 'remark'],
      form_fields_time: ['replaceDate'],
      validatorRules: {
        userId: {
          rules: [{
            required: true,
            message: '请选择更换人员!'
          }]
        },
        replaceDate: {
          rules: [{
            required: true,
            message: '请选择更换时间!'
          }]
        },
        reason: {
          rules: [{
            required: true,
            message: '请选择更换原因!'
          }]
        },
        calibration: {
          rules: [{
            required: true,
            message: '请选择是否标准!'
          }]
        },
        verification: {
          rules: [{
            required: true,
            message: '请选择是否核查!'
          }]
        }
      },
      loginUser: '',
      userTree: [],
      current: 0,
      siteDeviceDetailedList: {},

      /* table选中keys*/
      selectedRowKeys: [],

      /* table选中records*/
      selectionRows: [],
      dataTable: dataTable,
      // ModalText: '试剂更换新增后，不可编辑删除，请确认数据录入是否正确',
      // visible1: false,
      url: {
        querySiteDevice: '/om/chemical/replace/querySiteDevice/',
        queryProductAssets: '/om/chemical/replace/queryProductAssets/',
        queryChemicalReplaceItem: '/om/chemical/replace/item/',
        deleteChemicalReplaceItem: '/om/chemical/replace/item'
      },
      deviceId: ''
    };
  },
  props: ['pagePath'],
  watch: {
    currentSiteId: function currentSiteId(value) {
      this.siteId = value;
    },
    currentSiteName: function currentSiteName(newVal) {
      this.siteName = newVal;
    }
  },
  created: function created() {},
  methods: {
    selectAssetChemical: function selectAssetChemical(index1) {
      this.tableKey = index1;
      this.$refs.AssetChemicalModal.category = 22;
      this.$refs.AssetChemicalModal.disableSubmit = true;
      this.$refs.AssetChemicalModal.add(this.selectedAssetChemical, this.assetChemicalIds, this.deviceId);
    },
    changeUpload: function changeUpload(e, record) {
      e.sysFileList.forEach(function (item) {
        item.fileSrc = record.fileSrc;
      });
      e.fileDelList.forEach(function (item) {
        item.fileSrc = record.fileSrc;
      });
      console.log('e,record', e, record);
      record.sysFileList = e.sysFileList;
      record.fileDelList = e.fileDelList;
      console.log('this', this.tableData);
    },
    handleCancel: function handleCancel() {
      this.showUpload = false;
    },
    delTable: function delTable(index) {
      this.dataItem.splice(index, 1);
    },
    handleChangeTable: function handleChangeTable(record, index, index2) {
      var item = this.tableData[index2];
      item.forEach(function (item1, index1) {
        if (index1 > index && index1 < item.length - 4) {
          item1.value = '';
        }
      });
      this.$set(this.tableData, index2, item);
      this.$forceUpdate();
      console.log(item, index);
    },
    selectAssets: function selectAssets(record, index, index1) {
      this.tableKey1 = index1;
      this.selectedRecord = record;
      this.$refs.AssetListModal.siteId = this.siteId;
      this.$refs.AssetListModal.disableSubmit = true;
      this.$refs.AssetListModal.add(record.productName, record.equipmentId);
    },
    choseAssetChemical: function choseAssetChemical(productList) {
      var _this = this;

      this.dataItem.forEach(function (e, index) {
        if (index === _this.tableKey) {
          e.productChemicalId = productList[0].id;
          e.chemicalName = productList[0].name + '(' + productList[0].unit_dictText + ')';
          e.concentration = productList[0].intensity;
          e.concentrationUnit = productList[0].intensityUnit;
        }
      });
      this.$forceUpdate();
    },
    choseProduct: function choseProduct(productList) {
      var _this2 = this;

      this.deviceId = '';
      this.dataItem.forEach(function (e, index) {
        if (index === _this2.tableKey1) {
          e.assetEquipmentId = productList[0].id;
          e.deviceName = productList[0].productName;
          _this2.deviceId = productList[0].productId;
        }
      });
      this.$forceUpdate();
    },
    addTable: function addTable() {
      var _this3 = this;

      var newData = _toConsumableArray(this.dataItem);

      newData.push({
        assetEquipmentId: '',
        calibration: '',
        productChemicalId: '',
        verification: '',
        usageAmountUnit: '',
        remark: '',
        concentration: '',
        concentrationUnit: '',
        usageAmount: '',
        termOfValidity: '',
        configureTime: '',
        editable: true
      });
      this.dataItem = newData;
      var dataObj = {
        assetEquipmentId: '',
        calibration: '',
        productChemicalId: '',
        verification: '',
        usageAmountUnit: '',
        remark: '',
        concentration: '',
        concentrationUnit: '',
        usageAmount: '',
        termOfValidity: '',
        configureTime: '',
        editable: true
      };
      var arr = [];
      this.columnsItem.forEach(function (item, index) {
        if (index < _this3.columnsItem.length - 1) {
          var dataItem = {
            title: item.title,
            code: item.dataIndex,
            value: null
          };

          if (_this3.codeDict.indexOf(dataItem.code) > -1) {
            dataItem.fileSrc = "om_chemical_replace_item_".concat(dataItem.code);
            dataItem.srcId = null;
          }

          arr.push(dataItem);
        }
      });
      this.tableData.push(arr);
      this.tablePageIndex = this.tableData.length;
      console.log('tableData', this.tableData);
    },
    moment: moment,
    getData: function getData(value, e) {
      value['value'] = e;
    },
    getUnit: function getUnit(value, e) {
      value['value'] = e;
    },
    getCalibrationStatus: function getCalibrationStatus(value, e) {
      value['value'] = e;
    },
    getVerificationStatus: function getVerificationStatus(value, e) {
      value['value'] = e;
    },
    getUsageAmountUnit: function getUsageAmountUnit(index, e) {
      this.dataItem[index].usageAmountUnit = e;
    },
    changeUsageAmount: function changeUsageAmount(record, value) {
      if (record) {
        if (value != '') {
          if (value < 0) {
            this.$message.warning('产品数量不能为负数');
          } else {
            record.value = value;
          }
        }
      }

      this.$forceUpdate();
    },
    add: function add(siteId) {
      this.dataItem = [];
      this.tableData = [];
      if (undefined == siteId) this.$message.warning('请选择单个站点');
      this.edit({
        siteId: siteId
      });
    },
    edit: function edit(record) {
      var _this4 = this;

      this.tabsKey = '1';
      this.form.resetFields();
      this.model = Object.assign({}, record);
      this.queryUserTreeList(this.model.siteId);
      this.model.siteName = this.siteName;
      this.visible = true; // this.visible1 = false

      this.selectedRowKeys = [];
      this.selectionRows = []; // this.loadSiteDevice(this.siteId)

      if (this.model.id == undefined) {
        this.tableData = [];
        this.dataItem = [];
        this.model.userId = this.$store.getters.userInfo.id;
        this.model.replaceDate = moment(new Date(), 'YYYY-MM-DD HH:mm:ss');
      } else {
        this.getTableItem();
      }

      this.$nextTick(function () {
        var that = _this4;
        that.form.setFieldsValue(pick(that.model, that.form_fields)); //时间格式化

        var timeVal = {};
        that.form_fields_time.forEach(function (item, index) {
          timeVal[item] = that.model[item] ? moment(that.model[item], 'YYYY-MM-DD HH:mm:ss') : null;
        });
        that.form.setFieldsValue(timeVal);

        _this4.$refs.iwupload.loadUploadFiles();
      });
    },
    getTableItem: function getTableItem() {
      var _this5 = this;

      var chemicalReplaceItem = [];
      getAction(this.url.queryChemicalReplaceItem + this.model.id).then(function (res) {
        var arr = [];
        var arr3 = [];
        chemicalReplaceItem = res.result;
        chemicalReplaceItem.forEach(function (item) {
          var data = {
            id: item.id,
            assetEquipmentId: item.assetEquipmentId,
            calibration: item.calibration,
            productChemicalId: item.productChemicalId,
            verification: item.verification,
            remark: item.remark,
            concentration: item.concentration,
            concentrationUnit: item.concentrationUnit,
            usageAmount: item.usageAmount,
            usageAmountUnit: item.usageAmountUnit,
            termOfValidity: item.termOfValidity,
            configureTime: item.configureTime,
            deviceName: item.deviceName,
            chemicalName: item.chemicalName,
            editable: true
          };
          var arr1 = [];
          var arr2 = [];

          _this5.columnsItem.forEach(function (item1, index) {
            if (index < _this5.columnsItem.length - 1) {
              var dataItem = {
                title: item1.title,
                code: item1.dataIndex,
                value: data[item1.dataIndex]
              };

              if (dataItem.code == 'termOfValidity') {
                dataItem.value = dataItem.value ? moment(dataItem.value, 'YYYY-MM-DD HH:mm:ss') : null;
              }

              if (dataItem.code == 'configureTime') {
                dataItem.value = dataItem.value ? moment(dataItem.value, 'YYYY-MM-DD HH:mm:ss') : null;
              }

              if (_this5.codeDict.indexOf(dataItem.code) > -1) {
                dataItem.fileSrc = "om_chemical_replace_item_".concat(dataItem.code);
                dataItem.srcId = item.id;
              }

              arr1.push(dataItem);
              arr2.push(dataItem);
              arr2.id = item.id;
              arr2.deviceName = item.deviceName;
              arr2.chemicalName = item.chemicalName;
              arr2.assetEquipmentId = item.assetEquipmentId;
              arr2.productChemicalId = item.productChemicalId;
              arr2.concentration = item.concentration;
              arr2.concentrationUnit = item.concentrationUnit;
              arr2.usageAmountUnit = item.usageAmountUnit;
            }
          });

          arr.push(arr1);
          arr3.push(arr2);
        });
        _this5.tableData = arr;
        _this5.dataItem = arr3;
        console.log("dataItem:", _this5.tableData);
      });
    },
    handleOk: function handleOk() {
      var _this6 = this;

      var that = this; // this.visible1 = false
      // 触发表单验证

      this.form.validateFields(function (err, values) {
        if (!err) {
          that.confirmLoading = true;
          var formData = Object.assign(that.model, values);
          formData.replaceDate = formData.replaceDate ? formData.replaceDate.format('YYYY-MM-DD HH:mm:ss') : null;
          formData = _this6.$refs.iwupload.getUploadListToFromData(formData);
          var dataItem = [];
          that.tableData.forEach(function (item, index) {
            var obj = {};
            var sysFileList = [];
            var fileDelList = [];
            item.forEach(function (item1, index1) {
              obj[item1.code] = item1.value;

              if (item1.code == 'configureTime') {
                obj.configureTime = item1.value ? item1.value.format('YYYY-MM-DD HH:mm:ss') : null;
              }

              if (item1.code == 'termOfValidity') {
                obj.termOfValidity = item1.value ? item1.value.format('YYYY-MM-DD HH:mm:ss') : null;
              }

              if (item1.sysFileList) {
                sysFileList = sysFileList.concat(item1.sysFileList);
                fileDelList = fileDelList.concat(item1.fileDelList);
              }

              obj['assetEquipmentId'] = _this6.dataItem[index].assetEquipmentId;
              obj['productChemicalId'] = _this6.dataItem[index].productChemicalId;
              obj['usageAmountUnit'] = _this6.dataItem[index].usageAmountUnit;
              obj['id'] = _this6.dataItem[index].id;
            });
            obj.sysFileList = sysFileList;
            obj.fileDelList = fileDelList;
            dataItem.push(obj);
          });
          formData.chemicalReplaceItems = dataItem;
          var httpurl = '',
              method = '';

          if (!_this6.model.id) {
            httpurl = _this6.url.add ? _this6.url.add : _this6.pagePath;
            method = 'post';
          } else {
            httpurl = _this6.url.edit ? _this6.url.edit : _this6.pagePath;
            method = 'put';
          }

          console.log('formData', formData);
          httpAction(httpurl, formData, method).then(function (res) {
            if (res.success) {
              _this6.$refs.iwupload.resetUploadFiles();

              that.$notification.success({
                message: res.message
              });
              that.$emit('ok');
              that.close();
            } else {
              that.$notification.warning({
                message: res.message
              });
            }
          }).finally(function () {
            that.confirmLoading = false;
          });
        }
      });
    },
    handleDelete: function handleDelete(id) {
      var _this7 = this;

      if (this.dataItem.length <= 0) return;

      if (id) {
        this.tableData.splice(this.tablePageIndex - 1, 1);
        this.dataItem.splice(this.tablePageIndex - 1, 1);
        httpAction(this.url.deleteChemicalReplaceItem + '?id=' + id, '', 'DELETE').then(function (res) {
          if (res.success) {
            _this7.$notification.success({
              message: res.message
            });
          } else {
            _this7.$notification.warning({
              message: res.message
            });
          }
        });
      } else {
        this.tableData.splice(this.tablePageIndex - 1, 1);
        this.dataItem.splice(this.tablePageIndex - 1, 1);
      }

      if (this.dataItem.length > 1 && this.tablePageIndex > 1) {
        this.tablePageIndex--;
      } else {
        this.tablePageIndex = 1;
      }
    },
    queryUserTreeList: function queryUserTreeList(params) {
      var _this8 = this;

      var that = this;
      that.userTree = []; // 用户

      _queryUserTreeList().then(function (res) {
        if (res.success) {
          for (var i = 0; i < res.result.length; i++) {
            var temp = res.result[i];
            that.userTree.push(temp);
          }
        }
      });

      getAction(this.url.querySiteDevice + params).then(function (res) {
        if (res.success) {
          _this8.equipmentOptions = res.result;
        }
      });
    },
    onSelectChange: function onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeysTable = selectedRowKeys;
      this.selectedRowsTable = selectedRows;
      console.log("selectedRowKeys: ".concat(selectedRowKeys), 'selectedRows: ', selectedRows);
    },
    filterOption: function filterOption(input, option) {
      console.log('option', option.componentOptions.children[0].text);
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    }
  }
};